export default __webpack_public_path__ + "static/media/empty-bookcase.a64b9fff.jpeg";